import {
  UPDATE_ITEM_QUANTITY,
  DELETE_ITEM,
  UPDATING_ITEM_QUANTITY_ASYNC,
  UPDATE_ORDER_TYPE,
  UPDATE_CART_ITEMS
} from '../../GlobalStateContainer'


import { removeFromListById } from '../../../util/listUtility'

export const CartItems = (state = [], action) => {
  switch (action.type) {
    case UPDATE_ITEM_QUANTITY:
    case UPDATING_ITEM_QUANTITY_ASYNC:
      return state.map(item =>
        (item.Id === action.itemId)
          ? Object.assign({}, item, { Quantity: action.newQuantity })
          : item);
    case DELETE_ITEM:
      return removeFromListById(state, action.itemId);
    case UPDATE_CART_ITEMS:
      return action.cartItems;
    default:
      return state;
  }
}

export function OrderType(state = '', action) {
  switch(action.type) {
    case UPDATE_ORDER_TYPE:
      return action.orderType;
    default: 
      return state;
  }
}

export function HasRestrictedItems(state = false, action) {
  switch(action.type) {
    case UPDATE_CART_ITEMS:
      return action.cartItems.some(item => item.IsRestricted)
    default: 
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/Cart/cartReducers.js